/**
 * @file: 创建右键菜单UI
 * @author: xiaolong.huang@dmall.com
 */

import { contextMenuList } from './menuConfig';

function createContextmenu(): void {
    let $menu: JQuery<HTMLElement> = $('.shelvesbuild-w-contextmenus .J_MenuCont > .menu');

    createMenu($menu, contextMenuList);
}

function createMenu($menu: JQuery<HTMLElement>, contextMenuList: ContextMenuItem[]): void {
    let $menuList: JQuery<HTMLElement> = $(document.createElement('div'));

    contextMenuList.forEach((menuItem: ContextMenuItem): void => {
        let $item: JQuery<HTMLElement> = createItem(menuItem);

        $menuList.append($item);
    });
    $menu.html('');
    $menu.append($menuList.children());
}

function createItem(menuItem: ContextMenuItem): JQuery<HTMLElement> {
    let $item: JQuery<HTMLElement> = $(`
        <div class="item" data-type="${menuItem.type}">
            <div class="item-inner clearfix">
                <div class="zh">${menuItem.name}</div>
                <div class="en">${menuItem.shortCutKey}</div>
            </div>
        </div>
    `);
    let $childIcon: JQuery<HTMLElement> = $('<i class="has-child"></i>');
    let $childMenu: JQuery<HTMLElement> = $('<section class="menu child-menu"></section>');

    if (menuItem.children && menuItem.children.length) {
        $item.append($childIcon);
        $item.append($childMenu);
        $item.addClass('has-children');
        createMenu($childMenu, menuItem.children);
    }

    return $item;
}

export {
    createContextmenu
};
